import React, {FC, useRef} from 'react';
import {uploadAssistantFile} from "../../lib/api";

interface FileUploaderProps {
  assistant: any
  fileUploaded: (response: Response) => void
  setError: (error: string|null) => void
  setIsNetwork: any
}

const FileUploader: FC<FileUploaderProps> = ({assistant, fileUploaded, setError, setIsNetwork}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleUploadClick = () => {
    // Programmatically click the hidden file input element
    // This opens the file dialog
    setError(null)
    console.log(assistant.tools)
    if (assistant.tools.length == 0) {
      setError('You need to add Code Interpreter or Retrieval first in order to upload a file')
    } else {
      fileInputRef.current?.click();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    setIsNetwork(true)
    if (files && files[0]) {
      const selectedFile = files[0]
      uploadAssistantFile(selectedFile, assistant.id)
        .then((response) => {
          fileUploaded(response)
          setIsNetwork(false)
        })
        .catch(error => {
          setIsNetwork(false)
          setError('An unknown error occurred')
      })
    }
  };

  return (
    <div>
      {/* The file input is hidden and clicked programmatically */}
      <input
        type="file"
        style={{ display: 'none' }}
        ref={fileInputRef}
        onChange={handleFileChange}
      />
      <button onClick={handleUploadClick}>Upload File</button>
    </div>
  );
};

export default FileUploader;
